import { render, staticRenderFns } from "./IncomeBar.vue?vue&type=template&id=1a40548f&"
import script from "./IncomeBar.vue?vue&type=script&lang=js&"
export * from "./IncomeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IncomeBar.vue"
export default component.exports